import { useState, useCallback, useEffect } from 'react';

interface GlowAnimationOptions {
  duration?: number;
  pulseCount?: number;
}

export function useGlowAnimation({ 
  duration = 1500,
  pulseCount = 3
}: GlowAnimationOptions = {}) {
  const [isGlowing, setIsGlowing] = useState(false);

  const startGlow = useCallback(() => {
    if (!isGlowing) {
      setIsGlowing(true);
      const timer = setTimeout(() => {
        setIsGlowing(false);
      }, duration * pulseCount);
      return () => clearTimeout(timer);
    }
  }, [isGlowing, duration, pulseCount]);

  // Cleanup on unmount
  useEffect(() => {
    return () => setIsGlowing(false);
  }, []);

  return {
    isGlowing,
    startGlow
  };
}